module.exports = __webpack_public_path__ + "img/AmericanExpress.1cc73af4.svg";